document.addEventListener("DOMContentLoaded", () => {
  const productGrid = document.querySelector('#facets-results');
  const spinner = document.getElementById('infinite-scroll-spinner');
  const paginationWrapper = document.querySelector('.wrapper.mt-gap-theme');

  // Find the "next page" link by its position, not its text,
  // so it works in every language (aria-label is translated per language).
  function findNextLink(root) {
    return (
      root.querySelector('.pagination .text-right a') ||
      root.querySelector('.pagination a[rel="next"]') ||
      root.querySelector('.pagination a[aria-label="Next page"]')
    );
  }

  let nextPageLink = findNextLink(document);

  if (!productGrid || !nextPageLink) {
    console.log('Infinite scroll: Missing required elements', {
      productGrid: !!productGrid,
      nextPageLink: !!nextPageLink
    });
    return;
  }

  const observerTarget = document.createElement('div');
  observerTarget.style.height = '1px';
  document.body.appendChild(observerTarget);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && nextPageLink) {
        observer.unobserve(observerTarget);

        if (spinner) spinner.style.display = 'block';
        if (paginationWrapper) paginationWrapper.style.display = 'none';

        fetch(nextPageLink.href)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newProductsHTML = doc.querySelector('#facets-results')?.innerHTML;
            const newNextLink = findNextLink(doc);

            if (newProductsHTML) {
              productGrid.insertAdjacentHTML('beforeend', newProductsHTML);

              const newImages = productGrid.querySelectorAll('img.tile-media:not(.is-complete)');

              newImages.forEach(img => {
                if (img.complete) {
                  img.classList.add('is-complete');
                } else {
                  img.addEventListener('load', () => {
                    img.classList.add('is-complete');
                  });
                }
              });
            }

            if (spinner) spinner.style.display = 'none';

            if (newNextLink) {
              nextPageLink.href = newNextLink.href;
              if (paginationWrapper) paginationWrapper.style.display = 'none';
              observer.observe(observerTarget);
            } else {
              nextPageLink = null;
              observerTarget.remove();
              if (paginationWrapper) paginationWrapper.style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Infinite scroll error:', error);
            if (spinner) spinner.style.display = 'none';
            if (paginationWrapper) paginationWrapper.style.display = 'block';
          });
      }
    });
  }, {
    rootMargin: '600px',
  });

  observer.observe(observerTarget);
  console.log('Infinite scroll initialized successfully');
});